import React from 'react';
import { Button, Input, Select } from 'antd';

const { Option } = Select;

const StepProducts = ({ onNext, onBack, formData, updateField }) => {
  return (
    <div style={{ padding: '24px 0 0 0' }}>
      <div style={{ margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>         
          <div style={{ fontSize: 16, fontWeight: 700, color: '#1f2937' }}>Products (Include/Exclude)</div>
        </div>

        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 16 }}>
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: '#4b5563', marginBottom: 8 }}>List Type</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                type="button"
                onClick={() => updateField('listType', 'Included')}
                style={{ background: formData.listType === 'Included' ? '#EAF3FF' : '#F3F4F6', color: formData.listType === 'Included' ? '#1f6feb' : '#374151', borderRadius: 6, padding: '6px 10px', fontSize: 12, border: 'none', cursor: 'pointer' }}
              >
                Included
              </button>
              <button
                type="button"
                onClick={() => updateField('listType', 'Excluded')}
                style={{ background: formData.listType === 'Excluded' ? '#EAF3FF' : '#F3F4F6', color: formData.listType === 'Excluded' ? '#1f6feb' : '#374151', borderRadius: 6, padding: '6px 10px', fontSize: 12, border: 'none', cursor: 'pointer' }}
              >
                Excluded
              </button>
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>Inclusion list = only these SKUs are eligible. Exclusion list = all SKUs except these.</div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: '#4b5563', marginBottom: 8 }}>SKU Source</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                type="button"
                onClick={() => updateField('skuSource', 'Pre-Defined List')}
                style={{ background: formData.skuSource === 'Pre-Defined List' ? '#EAF3FF' : '#f3f4f6', border: formData.skuSource === 'Pre-Defined List' ? '1px solid #1f6feb' : '1px solid #d1d5db', color: formData.skuSource === 'Pre-Defined List' ? '#1f6feb' : '#374151', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}
              >
                Pre-Defined List
              </button>
              <button
                type="button"
                onClick={() => updateField('skuSource', 'Custom SKUs')}
                style={{ background: formData.skuSource === 'Custom SKUs' ? '#EAF3FF' : '#f3f4f6', border: formData.skuSource === 'Custom SKUs' ? '1px solid #1f6feb' : '1px solid #d1d5db', color: formData.skuSource === 'Custom SKUs' ? '#1f6feb' : '#374151', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}
              >
                Custom SKUs
              </button>
            </div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: '#4b5563', marginBottom: 8 }}>Included SKUs</div>
            <Input
              placeholder="GIFT001 × GIFT002 × add SKU, press Enter"
              value={formData.includedSkus}
              onChange={(e) => updateField('includedSkus', e.target.value)}
              style={{ height: 42, borderRadius: 8 }}
            />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
          <Button onClick={onBack} style={{ minWidth: 160, height: 42, borderRadius: 8, fontWeight: 600 }}>← Previous: Eligibility Conditions</Button>
          <Button type="primary" onClick={onNext} style={{ minWidth: 210, height: 42, borderRadius: 8, fontWeight: 600 }}>
            Next: Review & Publish →
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepProducts;
